// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import type { WarmUpFailure } from "../../../services/api/coldStartRetry";
import { SIGNED_OUT_MESSAGE } from "../../../services/api/demoData";

export const WAKING_UP_MESSAGE = "Waking up your workspace… This can take a couple of minutes.";
export const TRY_AGAIN_LABEL = "Try Again";
export const OFFLINE_BODY = "You're offline. Reconnect, then try again.";

export interface WarmUpFailureCopy {
  title: string;
  unreachable: string;
  rejected: string;
}

export const WORKSPACE_FAILURE_COPY: WarmUpFailureCopy = {
  title: "Couldn't Load Your Workspace",
  unreachable: "We couldn't reach Riddle. Check your connection, then try again.",
  rejected: "We couldn't load your workspace. Try again.",
};

export const SUBSCRIPTION_FAILURE_COPY: WarmUpFailureCopy = {
  title: "Couldn't Verify Your Subscription",
  unreachable: "We couldn't check your subscription. Check your connection, then try again.",
  rejected: "We couldn't verify your subscription. Try again.",
};

export function warmUpFailureBody(
  failure: WarmUpFailure,
  copy: WarmUpFailureCopy,
  online: boolean,
): string {
  if (failure === "signedOut") {
    return SIGNED_OUT_MESSAGE;
  }
  return online ? copy[failure] : OFFLINE_BODY;
}
